import { state } from './state';

export const mutations = {
	yearMutations(years) {
		state.years = years;
	}
};
